// webserver/frontend/src/components/sw-register.tsx
"use client"


import { useEffect } from "react"


export default function SwRegister() {
  useEffect(() => {
    if (typeof window === "undefined") return
    if (!("serviceWorker" in navigator)) return


    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch((err) => {
        if (process.env.NODE_ENV === "development") {
          console.warn("[SW] Registration failed:", err)
        }
      })
  }, [])


  return null
}
